import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationValuerPvConstants {
    static STEP_TITLE = "Value";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static DATA_COLLECTOR_FORM_CONTROL_NAME = "dataCollectorRecipient";
    static MUNICIPAL_VALUER_FORM_CONTROL_NAME = "municipalValuerRecipient";
    static ASSISTANT_VALUER_FORM_CONTROL_NAME = "assistantValuerRecipient";
    static MUNICIPAL_LABEL = "Municipal valuer";
    static ASSISTANT_VALUERS_LABEL = "Assistant valuers";
    static DATA_COLLECTORS_LABEL = "Data collectors";
}
